module.exports = __webpack_public_path__ + "static/media/icon_seat_1.f4cc1d49.png";